import type { ReactNode } from 'react';

import type { WebsiteBlock } from '@/api/schema';

import { articleLink } from './richTextDocument';
import styles from './RichTextContent.module.css';

function inline(text: string, runs?: WebsiteBlock['runs']) {
  if (!runs?.length) return text;
  return runs.map((run, index) => {
    const href = run.href ? articleLink(run.href) : null;
    let value: ReactNode = run.text;
    if (run.bold) value = <strong>{value}</strong>;
    if (run.italic) value = <em>{value}</em>;
    return <span key={index}>{href ? <a href={href}>{value}</a> : value}</span>;
  });
}

export function RichTextContent({
  blocks,
  fallback,
  imageUrl,
}: {
  blocks: WebsiteBlock[] | undefined;
  fallback: string;
  imageUrl: (id: string) => string;
}) {
  return (
    <div className={styles.content}>
      {blocks?.length ? (
        blocks.map((block, index) => {
          if (block.type === 'heading')
            return <h4 key={index}>{inline(block.text, block.runs)}</h4>;
          if (block.type === 'image')
            return block.image_id ? (
              <img key={index} src={imageUrl(block.image_id)} alt={block.alt} loading="lazy" />
            ) : null;
          if (block.type === 'list') {
            const List = block.ordered ? 'ol' : 'ul';
            return (
              <List key={index}>
                {block.items?.map((item, i) => (
                  <li key={i}>{inline(item, block.item_runs?.[i])}</li>
                ))}
              </List>
            );
          }
          return <p key={index}>{inline(block.text, block.runs)}</p>;
        })
      ) : (
        <p>{fallback}</p>
      )}
    </div>
  );
}
